import { api } from "./configs/axiosConfigs"

export const TypeAttributeAPI = {
    
    gettypeAttribute: async (data:any) => {
        const response = await api.get(
            '/typeattribute', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    gettypeAttributeByCompany: async (data:any) => {
        const response = await api.get(
            '/typeattribute/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createtypeAttribute: async (data: any) => {
        const response = await api.post(
            '/typeattribute/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    edittypeAttribute: async (idtype: number, data: any) => {
        const response = await api.patch(
            `/typeattribute/${idtype}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    changeStatustypeAttribute: async (idtype: number, data: any) => {
        const response = await api.patch(
            `/typeattribute/changeStatus/${idtype}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deletetypeAttribute: async (idtype: number) => {
        const response = await api.delete(
            `/typeattribute/${idtype}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}